import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { UtilsService } from '../../../core/utils.service';
import { CompaniesIntegrationsService } from '../companiesintegrations.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-integration-edit-apirest',
  templateUrl: './integration-edit-apirest.component.html',
  styleUrls: ['./integration-edit-apirest.component.scss']
})
export class IntegrationEditApirestComponent implements OnInit {

  /*
    - Organizaciones: sin acceso / lectura / lectura y escritura
    - Contactos: sin acceso / lectura / lectura y escritura
    - Actividades: sin acceso / lectura / lectura y escritura
  */

  public permissions: any = [
    { name: this.translateService.instant('component.integrations.no_permission'), value: "" },
    { name: this.translateService.instant('component.integrations.read_permission'), value: "read" },
    { name: this.translateService.instant('component.integrations.readwrite_permission'), value: "readwrite" }
  ];

  public integration: any = {
    configuration: {}
  };

  constructor(
    private dynamicDialogRef: DynamicDialogRef,
    private companiesIntegrationsService: CompaniesIntegrationsService,
    private messageService: MessageService,
    private utilsService: UtilsService,
    private translateService: TranslateService,
  ) { }

  ngOnInit() {
    this.companiesIntegrationsService.getByCode("apirest").subscribe(
      data => {
        if (data != null) {
          if (data.configuration == null) data.configuration = {};
          this.integration = data;
        }
        if (this.integration.configuration.user == null || this.integration.configuration.user == "") this.integration.configuration.user = this.utilsService.randomString(10);
        if (this.integration.configuration.password == null || this.integration.configuration.password == "") this.integration.configuration.password = this.utilsService.randomString(10);
      },
      error => {
        this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
      }
    );
  }

  save() {
    //const md5 = new Md5();
    //obj.configuration.password = md5.appendStr(obj.configuration.password).end();
    this.companiesIntegrationsService.save(this.integration.id, this.integration).subscribe(
      data => {
        this.dynamicDialogRef.close();
      },
      error => {
        this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
      }
    );
  }

  cancel() {
    this.dynamicDialogRef.close();
  }
}
